import { createContext } from 'react';

const FocusTrapContext = createContext({});

const initFocusTrap = (focusTrap) => {
  // ensure focus doesn't leave modal
  focusTrap.focusPage();
};

export { initFocusTrap };
export default FocusTrapContext;
